import { SubscriptionType } from '@modules/subscription/models'

export const isProductPackageSubscription = (type: SubscriptionType) =>
  ['PRODUCT_PACKAGE', 'PRODUCT_PACKAGE_VOUCHER'].includes(type)
